import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

// Drives the one "Cancel group" confirmation on All Groups and on a group's
// Settings tab (TMS-1713). The trigger hands over where to send the cancel,
// the group's name, and how many people hold access — when anyone does, the
// modal says plainly that they will lose it.
export default class extends Controller {
  static targets = ["modal", "form", "groupName", "access", "accessText"];

  open(event) {
    event.preventDefault();

    const { cancelUrl, groupName, accessText } = event.currentTarget.dataset;

    this.formTarget.action = cancelUrl;
    this.groupNameTarget.textContent = groupName;
    this.accessTextTarget.textContent = accessText || "";
    this.accessTarget.hidden = !accessText;

    Modal.getOrCreateInstance(this.modalTarget).show();
  }
}
